

export class FuelTypeStatusInput implements IFuelTypeStatusInput {
    /** The auto-generated id of the fuel type master */
    fuelTypeId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IFuelTypeStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelTypeId = _data["fuelTypeId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FuelTypeStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new FuelTypeStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelTypeId"] = this.fuelTypeId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IFuelTypeStatusInput {
    /** The auto-generated id of the fuel type master */
    fuelTypeId: number;
    /** The updated status */
    status: number;
}

